//CLAN
export var CLAN_CONFIG = "clanConfig";
export var CLAN_PERMISSIONS = "clanPermissions";
export var CLAN_API_PROFILE = "clanApiProfile";
export var CLAN_SEARCH_FILTER = "ClanSearchFilter";
export var CLAN_API_SEARCH_FILTER = "ClanApiSearchFilter";
export var CLAN_PERSONAL_SEARCH_FILTER = "ClanPersonalSearchFilter";
//PLAYER
export var PLAYER_API_PROFILE = "playerApiProfile";
export var PLAYER_SEARCH_FILTER = "playerSearchFilter";
export var PLAYER_API_SEARCH_FILTER = "playerApiSearchFilter";
export var PLAYER_PERSONAL_SEARCH_FILTER = "playerPersonalSearchFilter";
//MAN_TO_MANY
export var PLAYERS_ON_CLAN = "playersOnClan";
export var MATCHS = "matchs";
export var MATCH_DECISIONS = "matchDecisions";
//TODO: check if the removing action of as const is realy okay
//LIMITS
export var MIN_TOWNHALL_LEVEL = 5;
//DB ACTIONS (CLAN PERMISSIONS)
export var CREATE = "CREATE";
export var READ = "READ";
export var UPDATE = "UPDATE";
export var DELETE = "DELETE";
export var PERMISSIONS = [CREATE, READ, UPDATE, DELETE];
export var MUTATION_PERMISSIONS = [CREATE, UPDATE, DELETE];
export var UPSERT_PERMISSIONS = [CREATE, UPDATE];
//IMPORTANT VARS
export var S_IN_MS = 1000;
export var M_IN_MS = 60 * S_IN_MS;
export var H_IN_MS = 60 * M_IN_MS;
export var API_UPDATE_SCHEDULE = H_IN_MS;
export { FCM_PLATFORM_CHANNEL, FCM_PLATFORM_DB_UPDATED, FCM_PLATFORM_EVENT_TYPES, } from "./fcm-platform-events.js";
export { CLAN_PERMISSION_TEMPLATE_IDS, CLAN_PERMISSION_TEMPLATES, } from "./clan-permission-templates.js";
export var TRUSTED_AUTH_PROVIDERS = ["google", "discord", "apple"];
